import { NgModule } from '@angular/core';

import { SharedModule }              from '../shared/shared.module';
import { TableModule }               from '../table/table.module';
import { TemplatedWordingComponent } from './templated-wording.component';
import { TemplatedWordingService }   from './templated-wording.service';

@NgModule({
  declarations: [
    TemplatedWordingComponent
  ],
  entryComponents: [
    TemplatedWordingComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    TemplatedWordingService
  ]
})
export class TemplatesModule {}
